import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { Select } from 'primeng/select'
import { IftaLabel } from 'primeng/iftalabel'
import { AlbertBaseControlDirective } from '@directives/albert-base-control.directive'

@Component({
  selector: 'albert-select',
  standalone: true,
  imports: [ReactiveFormsModule, Select, IftaLabel],
  templateUrl: './albert-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertSelectComponent extends AlbertBaseControlDirective {
  public readonly editable = input<boolean>(false)
  public readonly filter = input<boolean>(false)
  public readonly dataKey = input<string>()
  public readonly optionLabel = input<string>()
  public readonly optionValue = input<string>()

  public readonly filterEvent = output<unknown>()
  public readonly showEvent = output()
}
